import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addDoc, collection, updateDoc, doc, setDoc, serverTimestamp, getDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import { Box, Typography, TextField, Button, CircularProgress } from '@mui/material';
import logo from '../../images/logo.svg';
import { colors, typography, radius, inputSx, btnPrimary } from '../../theme';

const ShopSetupPage = () => {
  const navigate  = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  useEffect(() => {
    const check = async () => {
      const user = auth.currentUser;
      if (!user) { navigate('/signin'); return; }
      const userSnap = await getDoc(doc(db, 'users', user.uid));
      if (userSnap.exists() && userSnap.data().shopId) navigate(`/user/${userSnap.data().shopId}/dashboard`);
    };
    check();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user) { navigate('/signin'); return; }
    const data = new FormData(e.currentTarget);
    const shopName = data.get('shopName'), barberName = data.get('barberName'), phone = data.get('phone'), address = data.get('address');
    if (!shopName || !barberName || !phone || !address) { setError('Please fill in all fields.'); return; }
    setError(''); setLoading(true);
    try {
      const shopRef = await addDoc(collection(db, 'shops'), { type:'shop', isActive:true, shopName, barberName, phone, email:user.email, ownerId:user.uid, address, image:'', ratings:{average:0,totalReviews:0}, services:[{name:'Haircut',price:20,duration:30},{name:'Beard Trim',price:15,duration:20}], operatingHours:{monday:{open:'09:00',close:'18:00',isOff:false},tuesday:{open:'09:00',close:'18:00',isOff:false},wednesday:{open:'09:00',close:'18:00',isOff:false},thursday:{open:'09:00',close:'18:00',isOff:false},friday:{open:'09:00',close:'18:00',isOff:false},saturday:{open:'09:00',close:'14:00',isOff:false},sunday:{open:'00:00',close:'00:00',isOff:true}}, createdAt:serverTimestamp() });
      await updateDoc(shopRef, { qrCodeId: shopRef.id });
      await setDoc(doc(db, 'users', user.uid), { shopId: shopRef.id }, { merge: true });
      navigate(`/user/${shopRef.id}/dashboard`);
    } catch (err) { console.error(err); setError('Failed to create shop. Try again.'); }
    setLoading(false);
  };

  return (
    <Box sx={{ minHeight:'100vh', bgcolor:colors.bg, display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', px:2, py:4 }}>
      <Box sx={{ width:'100%', maxWidth:420 }}>
        <Box sx={{ display:'flex', justifyContent:'center', mb:3 }}><img src={logo} alt="DigitalQ" style={{ width:80, height:'auto' }} /></Box>
        <Box sx={{ bgcolor:colors.bgCard, border:`1px solid ${colors.border}`, borderRadius:radius.lg, p:3 }}>
          <Typography sx={{ fontFamily:typography.poppins, fontSize:22, fontWeight:700, color:colors.textPrimary, mb:0.5 }}>Set Up Your Shop</Typography>
          <Typography sx={{ fontSize:13, color:colors.textFaint, mb:3 }}>Tell us about your barber shop</Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display:'flex', flexDirection:'column', gap:2 }}>
            <TextField name="shopName"   label="Shop Name"    required size="small" sx={inputSx} />
            <TextField name="barberName" label="Your Name"    required size="small" sx={inputSx} />
            <TextField name="address"    label="Shop Address" required size="small" sx={inputSx} />
            <TextField name="phone"      label="Phone Number" required size="small" sx={inputSx} />
            {error && <Typography sx={{ fontSize:12, color:colors.error, textAlign:'center' }}>{error}</Typography>}
            <Button type="submit" fullWidth variant="contained" disabled={loading} sx={{ ...btnPrimary, fontSize:14, py:1.2 }}>
              {loading ? <CircularProgress size={18} sx={{ color:colors.bgDeep }} /> : 'Create My Shop ✂️'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ShopSetupPage;